/* Home Saved — hydrates the wishlist rail from local storage / Rivo.
   (Recently viewed is rendered by the separate recently-viewed-products
   section, which uses product-card-v2 + section rendering API.) */

(() => {
  const WISHLIST_KEYS = ['theme:wishlist', 'wishlist:items', 'wishlist'];

  function readJsonKey(key) {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) { return null; }
  }

  function readWishlist() {
    for (const k of WISHLIST_KEYS) {
      const v = readJsonKey(k);
      if (Array.isArray(v) && v.length) return v;
      if (v && Array.isArray(v.items) && v.items.length) return v.items;
    }
    return [];
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function buildItem(p) {
    const url = p.url || (p.handle ? `/products/${p.handle}` : '#');
    const img = p.image || p.featured_image || '';
    const title = p.title || '';
    const a = document.createElement('a');
    a.href = url;
    a.innerHTML = `
      <div class="home-frame home-frame--black">
        <div class="home-frame__mat">
          <div class="home-frame__art" ${img ? `style="background-image: url('${img}');"` : ''}></div>
        </div>
      </div>
      <div class="home-saved-and-recent__title">${escapeHtml(title)}</div>
    `;
    return a;
  }

  function hydrateRail(railEl, items) {
    const slot = railEl.querySelector('[data-items]');
    const limit = parseInt(railEl.dataset.limit, 10) || 4;
    if (!items || !items.length) return false;
    slot.innerHTML = '';
    items.slice(0, limit).forEach((p) => slot.appendChild(buildItem(p)));
    railEl.removeAttribute('hidden');

    const eb = railEl.querySelector('[data-ref="wishlistEyebrow"]');
    if (eb) eb.textContent = `Saved · ${items.length}`;
    return true;
  }

  function init() {
    const section = document.querySelector('.home-saved-and-recent');
    if (!section) return;

    const wishlistRail = section.querySelector('[data-rail="wishlist"]');
    if (!wishlistRail) return;

    const ok = hydrateRail(wishlistRail, readWishlist());
    if (!ok) return;

    section.removeAttribute('data-empty');
    section.removeAttribute('hidden');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
